module.exports = __webpack_public_path__ + "static/media/blog2.83e08413.jpg";